<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="客户信息：" prop="nameOrPho">
            <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" size="small" />
          </el-form-item>
          <el-form-item label="客户身份：" prop="levelId">
            <el-select v-model="query.levelId" placeholder="请选择客户身份" clearable size="small">
              <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="折扣组：">
            <el-select v-model="query.profitRatioId" placeholder="请选择折扣组" clearable size="small">
              <el-option :label="item.title" :value="item.id" v-for="item in discountList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用友编码：" prop="code">
            <el-input v-model="query.code" placeholder="请输入用友编码" size="small" />
          </el-form-item>
          <el-form-item label="账号类型：">
            <el-select v-model="query.isMain" placeholder="请选择账号类型" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="主账号" :value="1"></el-option>
              <el-option label="子账号" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="认证类型：">
            <el-select v-model="query.certificates_type" placeholder="请选择认证类型" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="企业认证" :value="1"></el-option>
              <el-option label="个人认证" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="通商云ID：" prop="yuntognshangId">
            <el-input v-model="query.yuntognshangId" placeholder="请输入通商云ID" size="small" />
          </el-form-item> -->
          <el-form-item label="是否登录APP：">
            <el-select v-model="query.isLoginApp" placeholder="请选择是否登录APP" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区域：">
            <el-cascader v-model="query.addrid"  :props="cascaderProps" collapse-tags :options="addressList" :show-all-levels="false" clearable placeholder="请选择所属区域" size="small"></el-cascader>
          </el-form-item>
          <el-form-item label="业务员：">
            <el-select v-model="query.ywName" filterable placeholder="请选择业务员" :filter-method="businessFilter" clearable size="small" @blur="getBusinessList()">
              <el-option :label="`${item.name}（${item.levelName}）${item.pho}`" :value="item.name" v-for="item in businessList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="技术老师：">
            <el-select v-model="query.technicianName" filterable placeholder="请选择技术老师" clearable size="small" :filter-method="technicianFilter" @blur="getTechnicianList()">
              <el-option :label="`${item.realName}（${item.levelName}）${item.mobile}`" :value="item.realName" v-for="item in technicianList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属城市公司：">
            <el-select v-model="query.cityCompanyId" filterable placeholder="请选择所属城市公司" clearable size="small">
              <el-option :label="item.value" :value="item.key" v-for="item in companyList" :key="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="加入时间" :value="1"></el-option>
              <el-option label="修改时间" :value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="3.0画像：" prop="portraitStatus">
            <el-select v-model="query.portraitStatus" placeholder="全部" clearable size="small">
              <el-option label="符合·有效" :value="1" />
              <el-option label="不符合" :value="2" />
              <el-option label="已到期" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="服务周期：" prop="serviceCycleFilter">
            <el-select v-model="query.serviceCycleFilter" placeholder="全部" clearable size="small">
              <el-option label="月度服务" :value="1" />
              <el-option label="季度服务" :value="2" />
              <el-option label="暂不服务" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-upload style="display: inline-block;margin-right: 8px" :action="uploadImgUrl" :show-file-list="false" :http-request="uploadFile" :file-list="fileList" v-hasPermi="['client:clientList:import']">
            <el-button size="mini" type="primary" plain>导入</el-button>
          </el-upload>
          <el-button type="primary" size="mini" @click="handleDownTemplate" plain style="margin-right: 8px">下载模板</el-button>
          <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['client:clientList:export']" style="margin-right: 8px">导出</el-button>
          <el-button type="primary" size="mini" @click="handleDownloadFollowUp" plain v-hasPermi="['client:clientList:exportFllow']" style="margin-right: 8px">导出跟进记录</el-button>
          <el-dropdown @command="handleCommand" style="margin-right: 8px">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(null,13)">转给其他业务员</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(null,14)">更换老师</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(null,15)" v-hasPermi="['client:clientList:technical']">移入技术线客户公海</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['client:clientList:add']" style="margin-right: 8px">添加客户</el-button>
          <img src="../../../assets/Vector.png" class="vector" @click="handleChangeFields">
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <el-table-column type="selection" width="50" :selectable="checkboxT" disabled="true" fixed />
        <el-table-column :width="item.width" v-for="(item,index) in dynamicHeaders" :key="index" :prop="item.prop" :label="item.label" :fixed="index<2" :sortable="item.isSortable" :align="item.align">
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.customer.id)" v-if="item.prop === 'customer'">
              <el-link type="primary">{{row.customer.name}}({{row.customerLevel.name}})</el-link><br />
              <el-link type="primary">{{row.customer.pho}}</el-link>
            </div>
            <span v-else-if="item.prop === 'customer.userId'">{{row.customer.userId}}-<span>用户状态：{{ row.customerUserPO.deleted?'已删除':'正常' }}</span></span>
            <span v-else-if="item.prop === 'customer.id'">{{row.customer.id}}-<span>客户状态：{{ row.customer.deleted?'已删除':'正常' }}</span>
            -<span>授权状态：{{ row.customer.state==1?'正常':row.customer.state==2?'待审核':row.customer.state==-1?'驳回':row.customer.state==3?'撤回':'异常' }}</span></span>
            <span v-else-if="item.prop === 'sysProfitRatio.title'">{{row.sysProfitRatio && row.sysProfitRatio.title}}</span>
            <span v-else-if="item.prop === 'customer.source'">{{row.customer.source}}</span>
            <span v-else-if="item.prop === 'customer.code'">{{row.customer.code}}</span>
            <span v-else-if="item.prop === 'mainId'">{{row.customer.mainId?'子账号':'主账号'}}</span>
            <div v-else-if="item.prop === 'mainInfo' && row.customer.mainId && row.mainCustomerPO">
              <span>{{row.mainCustomerPO.name}}({{row.mainCustomerLevel ?'(' + row.mainCustomerLevel.name + ')' : ''}})</span><br />
              <span>{{row.mainCustomerPO.pho}}</span>
            </div>
            <template v-else-if="item.prop === 'customerCertificates'">
              <div @click="handleShow(row)" v-if="row.customerCertificates">
                <el-link type="primary">认证类型：{{row.customerCertificates.certificatesType==1?'企业认证':(row.customerCertificates.certificatesType==2?'个人认证':'未认证')}}</el-link><br />
                <el-link type="primary" v-if="row.customerCertificates.certificatesType==1">企业名称：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
                <el-link type="primary" v-if="row.customerCertificates.certificatesType==2">姓名：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
              </div>
              <div v-else>
                <span>未认证</span>
              </div>
            </template>
            <span v-else-if="item.prop === 'customerRegistrationPO'">
              {{row.customerRegistrationPO?(row.customerRegistrationPO.state === 1?'审核通过':(row.customerRegistrationPO.state === 2?'审核失败':'未审核')) :'正常'}}
            </span>
            <span v-else-if="item.prop === 'tsyId'">{{row.customerUserPO.bizUserId}}</span>
            <span v-else-if="item.prop === 'customerClassify.name'">{{row.customerClassify?row.customerClassify.name:''}}</span>
            <template v-else-if="item.prop === 'addr'">
              <span v-if="row.addr.length">{{row.addr[0].regionName}}{{row.addr[1].regionName}}{{row.addr.length==3?row.addr[2].regionName:''}}</span>
            </template>
            <template v-else-if="item.prop === 'line'">
              <span v-if="row.line">{{row.line.name}}({{row.lineLevel.name}})</span>
            </template>
            <template v-else-if="item.prop === 'technicianInfo'">
              <span v-if="row.technicianInfo">{{row.technicianInfo.realName}}({{row.technicalServiceLevel.name}})</span>
            </template>
            <span v-else-if="item.prop === 'cityCompany'">{{row.cityCompany?row.cityCompany.name:''}}</span>
            <template v-else-if="item.prop === 'userWallet'">
              <div class="flexs">
                <div style="display: flex;flex-direction: column;">
                  <span>余额：{{row.userWallet?row.userWallet.balance:0}}</span>
                  <span>零售价：{{row.userWallet?row.userWallet.xiaoduMoney:0}} </span>
                  <span>赠送：{{row.userWallet?row.userWallet.tuition :0}}</span>
                  <span> 积分账户：{{row.userWallet?row.userWallet.integral:0}}</span>
                </div>
                <!-- <div style="display: flex;flex-direction: column;margin-left: 5px;">
              
                </div> -->
              </div>
            </template>
            <template v-else-if="item.prop === 'state'">
              <div v-if="!row.customer.mainId && row.customerUserPO.firstLoginTime">
                <el-switch v-model="row.customer.canStudy" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
              </div>
            </template>
            <span v-else-if="item.prop === 'isLogin'">{{row.customerUserPO.firstLoginTime?'已登录':'未登录'}}</span>
            <span v-else-if="item.prop === 'customer.joinTime'">{{row.customer.joinTime}}</span>
            <span v-else-if="item.prop === 'customer.operatedTime'">{{dayjs(row.customer.operatedTime).format("YYYY-MM-DD HH:mm:ss")}}</span>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="3.0画像" align="center" width="110">
          <template slot-scope="{row}">
            <el-tag v-if="row.portraitValid" type="success" size="mini">符合·有效</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="服务周期" align="center" width="110">
          <template slot-scope="{row}">{{ serviceCycleText(row.serviceCycle) }}</template>
        </el-table-column>
        <el-table-column label="符合画像累计次数" align="center" width="140">
          <template slot-scope="{row}">{{ row.portraitMarkCount || 0 }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <!-- <el-button type="text" @click="handleUpdate(row,0)" v-if="!row.customer.mainId && row.subCount && row.customerUserPO.firstLoginTime">查看子账户</el-button> -->
            <el-button type="text" @click="handleUpdate(row,0)" v-if="!row.customer.mainId && row.subCount && row.customer.name" v-hasPermi="['client:clientList:accounts']">查看子账户</el-button>
            <!-- <el-button type="text" @click="handleUpdate(row,2)"
              v-if="(!row.customer.mainId|| !row.customerUserPO.firstLoginTime) && row.customer.name && !row.customerRegistrationIngCount">修改身份</el-button> -->
            <el-button type="text" @click="handleUpdate(row,1)" v-hasPermi="['client:clientList:edit']">编辑</el-button>
            <el-button type="text" @click="handleUpdate(row,9)" v-if="row.customer.mainId && row.customer.name" v-hasPermi="['client:clientList:modules']">使用模块</el-button>
            <!-- <el-button type="text" @click="handleUpdate(row,10)" v-if="row.customer.mainId">日志记录</el-button> -->
            <el-button type="text" @click="handleUpdate(row,3)" v-if="!row.customer.mainId && row.customer.name" v-hasPermi="['client:clientList:label']">打标签</el-button>
            <el-dropdown @command="handleCommand">
              <el-button type="text">更多<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <template v-if="!row.customer.mainId">
                  <el-dropdown-item :command="beforeHandleCommand(row,3)" v-if="row.customer.name" v-hasPermi="['client:clientList:transfer']">转给其他业务员</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(row,4)" v-if="row.customer.name" v-hasPermi="['client:clientList:teacher']">更换老师</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(row,0)" v-if="row.customer.name" v-hasPermi="['client:clientList:technical']">移入技术线客户公海</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(row,2)" v-if="!row.customer.mainId && !row.customerRegistrationIngCount" v-hasPermi="['client:clientList:identity']">修改身份</el-dropdown-item>
                  <!-- <el-dropdown-item :command="beforeHandleCommand(row,4)" >修改客户折扣</el-dropdown-item> -->
                  <el-dropdown-item :command="beforeHandleCommand(row,5)" v-if="row.customer.name" v-hasPermi="['client:clientList:area']">更换区域</el-dropdown-item>
                </template>
                <el-dropdown-item :command="beforeHandleCommand(row,6)" v-if="row.customer.name">实名认证</el-dropdown-item>
                <template v-if="!row.customer.mainId">
                  <el-dropdown-item :command="beforeHandleCommand(row,7)" v-if="row.customer.name" v-hasPermi="['client:clientList:discount']">下单折扣</el-dropdown-item>
                  <!-- <el-dropdown-item :command="beforeHandleCommand(row,8)" >分润比例</el-dropdown-item> -->
                  <el-dropdown-item :command="beforeHandleCommand(row,11)" v-hasPermi="['client:clientList:account']">禁用账户</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(row,20)">调整城市公司</el-dropdown-item>
                </template>
                <el-dropdown-item :command="beforeHandleCommand(row,12)" v-hasPermi="['client:clientList:login']">{{row.customerUserPO.entryInhibited?'恢复登录':'禁止登录'}}</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,22)">地址管理</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,21)">清除缓存</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,10)">日志记录</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,23)" v-if="row.customer.name" v-hasPermi="['client:clientList:otherFollow']">添加其他跟进</el-dropdown-item>
                
                <!-- <el-dropdown-item :command="beforeHandleCommand(row,22)">权限管理</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <banner-add ref="bannerAdd" :standingList="standingList" :discountList="discountList" :configList="configList" :labelList="labelList" :addressList="addressList" :popType="popType" @created="handleAddCallback" />
    <!-- 打标签 -->
    <label-add ref="labelAdd" @created="doQueryList({})" :labelList="labelList" />
    <!-- 企业认证 -->
    <client-show ref="clientShow" @created="doQueryList({})"></client-show>
    <!-- 子账号 -->
    <subaccount ref="subaccount" @created="doQueryList({})" @handleShow="handleShowDetail" @handleUpdate="handleUpdates"></subaccount>
    <!-- 禁用账户弹窗 -->
    <el-dialog title="禁用账户" :visible.sync="disableAccountVisible" width="500px" :close-on-click-modal="false">
      <div class="disable-account-content">
        <div class="warning-text">
          <i class="el-icon-warning" style="color: #E6A23C; margin-right: 8px;"></i>
          是否确认禁用账户，一旦禁用账户将无法登录，需重新注册
        </div>
         <div class="checkbox-section">
          <el-checkbox v-model="isDeleteSysUser" style="margin-top: 15px;">
            是否清空登录用户
          </el-checkbox>
          <div style="color: #909399; font-size: 12px; line-height: 18px; margin-top: 6px;">
            勾选后该手机号的登录账号会被清空。若这个人还有其他有效资料（如业务员）在用同一个手机号登录，请不要勾选，否则那条资料也会登不上。
          </div>
        </div> 
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="disableAccountVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDisableAccount">确定</el-button>
      </div>
    </el-dialog>
    <change-fields-vue ref="fieldsPopup" :allTemplate="allTemplate" :cList="dynamicHeaders" @updated="doColumnList" />
    <city-company-vue ref="cityCompanyVue" @created="cityCompanySubmit" />
    <rights-vue ref="rightsVue" @created="doQueryList({})" />
    <address-manage-vue ref="addressManageVue" />
    <!-- 添加其他跟进弹窗 -->
    <el-dialog title="添加其他跟进" :visible.sync="otherFollowDialogVisible" width="640px" :close-on-click-modal="false" @close="resetOtherFollowForm">
      <el-form :model="otherFollowForm" :rules="otherFollowRules" ref="otherFollowForm" label-width="120px">
        <el-form-item label="跟进类型" prop="followUpCategoryId">
          <el-select v-model="otherFollowForm.followUpCategoryId" placeholder="请选择跟进类型" style="width: 100%">
            <el-option v-for="(item, idx) in otherFollowCategoryList" :key="typeof item === 'string' ? idx : item.id" :label="typeof item === 'string' ? item : item.name" :value="typeof item === 'string' ? idx : item.id"
              v-if="item.enable == '1' || item.enable === true" />
          </el-select>
        </el-form-item>
        <el-form-item label="跟进方式" prop="followUpType">
          <el-select v-model="otherFollowForm.followUpType" placeholder="请选择跟进方式" style="width: 100%">
            <el-option label="线下会面" :value="1" />
            <el-option label="线上沟通" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="跟进目的" prop="followUpPurpose">
          <el-input v-model="otherFollowForm.followUpPurpose" type="textarea" :rows="3" placeholder="请输入跟进目的" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="跟进内容" prop="followUpContent">
          <el-input v-model="otherFollowForm.followUpContent" type="textarea" :rows="3" placeholder="请输入跟进内容" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="跟进结果" prop="followUpResult">
          <el-input v-model="otherFollowForm.followUpResult" type="textarea" :rows="3" placeholder="请输入跟进结果" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="给客户的承诺" prop="customerPromise">
          <el-input v-model="otherFollowForm.customerPromise" type="textarea" :rows="2" placeholder="请输入给客户的承诺" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="客户基础信息" prop="customerBasicInfo">
          <el-input v-model="otherFollowForm.customerBasicInfo" type="textarea" :rows="2" placeholder="请输入客户基础信息" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="跟进图片" prop="followUpUrl">
          <more-image-upload v-model="otherFollowUrlList" :limit="9" fileTxt="上传附件" />
        </el-form-item>
        <el-form-item label="跟进时间" prop="followUpTime">
          <el-date-picker v-model="otherFollowForm.followUpTime" type="datetime" placeholder="请选择跟进时间"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
        </el-form-item>
        <el-form-item label="下次跟进时间" prop="nextFollowUpTime">
          <el-date-picker v-model="otherFollowForm.nextFollowUpTime" type="datetime" placeholder="请选择下次跟进时间"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="otherFollowDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmitOtherFollow" :loading="otherFollowSubmitLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import bannerAdd from './add'
import clientShow from './show'
import labelAdd from './addLabel'
import subaccount from './subaccount'
import clientListApi from '@/api/client/clientList'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import customerLevelApi from '@/api/sys/customerLevel'
import sysProfitRatioApi from '@/api/sys/sysProfitRatio'
import sysAddrApi from '@/api/sys/sysAddr'
import clientLabelApi from '@/api/client/label'
import technicianInfoApi from '@/api/technical/technicianInfo'
import Pagination from '@/components/Pagination'
import userApi from '@/api/sys/user'
import cityCompanyApi from '@/api/sys/cityCompany'
import changeFieldsVue from '@/views/common/changeFields.vue'
import cityCompanyVue from './cityCompany.vue'
import rightsVue from './rights.vue'
import otherFollowCustRecordApi from '@/api/client/otherFollowCustRecord'
import MoreImageUpload from '@/components/MoreImageUpload'
import addressManageVue from './addressManage.vue'
import { serviceCycleText } from '@/utils/customerPortrait'
export default {
  components: {
    Pagination,
    bannerAdd,
    labelAdd,
    clientShow,
    subaccount,
    changeFieldsVue,
    cityCompanyVue,
    rightsVue,
    addressManageVue,
    MoreImageUpload
  },
  data() {
    return {
      // level 6:研修班 7:体验班 8:普通用户
      list: [],
      total: 0,
      popType: null,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        customerType: 3,
        portraitStatus: '',
        serviceCycleFilter: ''
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true
        // multiple: true
      },
      selectItems: [],
      activeName: '1',
      standingList: [],
      discountList: [],
      configList: [],
      labelList: [],
      addressList: [],
      technicianList: [],
      businessList: [],
      companyList: [],
      dateTime: null,
      allTemplate: [{
        label: '用户信息',
        prop: 'customer.userId',
        align: 'center'
      },{
        label: '客户信息',
        prop: 'customer.id',
        width: '160px',
        align: 'center'
      }, {
        label: '客户信息',
        prop: 'customer',
        width: '160px',
        align: 'center'
      }, {
        label: '折扣组',
        prop: 'sysProfitRatio.title',
        // width: '120px',
        align: 'center'
      }, {
        label: '客户分类',
        prop: 'customerClassify.name',
        // width: '120px',
        align: 'center'
      }, {
        label: '客户来源',
        prop: 'customer.source',
        align: 'center'
      }, {
        label: '用友编码',
        prop: 'customer.code',
        // width: '130px',
        align: 'center'
      }, {
        label: '账号类型',
        prop: 'mainId',
        align: 'center'
      }, {
        label: '主账号信息',
        prop: 'mainInfo',
        width: '160px',
        align: 'center'
      }, {
        label: '子账号数量',
        prop: 'subCount',
        // width: '100px',
        align: 'center'
      }, {
        label: '认证信息',
        prop: 'customerCertificates',
        width: '160px'
      }, {
        label: '凭证审核',
        prop: 'customerRegistrationPO',
        // width: '160px'
      },
      {
        label: '通商云ID',
        prop: 'tsyId',
        align: 'center'
      }, {
        label: '所属区域',
        prop: 'addr',
        width: '120px',
        align: 'center'
      }, {
        label: '发展业务线',
        prop: 'line',
        width: '160px',
        align: 'center'
      }, {
        label: '发展技术线',
        prop: 'technicianInfo',
        width: '160px',
        align: 'center'
      }, {
        label: '所属城市公司',
        prop: 'cityCompany',
        width: '110px',
        align: 'center'
      }, {
        label: '账户剩余明细',
        prop: 'userWallet',
        width: '180px'
      }, {
        label: '学习权限',
        prop: 'state',
        width: '120px',
        align: 'center'
      }, {
        label: '是否登录APP',
        prop: 'isLogin',
        // width: '110px',
        align: 'center'
      }, {
        label: '加入时间',
        prop: 'customer.joinTime',
        isSortable: true,
        width: '160px',
        align: 'center'
      }, {
        label: '修改时间',
        prop: 'customer.operatedTime',
        isSortable: true,
        width: '160px',
        align: 'center'
      }, {
        label: '操作人',
        prop: 'operated_by',
        align: 'center'
      }
      ],
      dynamicHeaders: [],
      disableAccountVisible: false,
      isDeleteSysUser: false,
      currentDisableRow: null,
      uploadImgUrl: '', // 上传文件地址
      fileList: [], // 文件列表
      otherFollowDialogVisible: false,
      otherFollowSubmitLoading: false,
      otherFollowCategoryList: [],
      otherFollowUrlList: [],
      otherFollowForm: {
        customerId: null,
        followUpCategoryId: null,
        followUpType: null,
        followUpPurpose: '',
        followUpContent: '',
        followUpResult: '',
        customerPromise: '',
        customerBasicInfo: '',
        followUpUrl: '',
        followUpTime: null,
        nextFollowUpTime: null
      },
      otherFollowRules: {
        followUpCategoryId: [{ required: true, message: '请选择跟进类型', trigger: 'change' }],
        followUpPurpose: [{ required: true, message: '请输入跟进目的', trigger: 'blur' }],
        followUpTime: [{ required: true, message: '请选择跟进时间', trigger: 'change' }]
      }
    }
  },
  created() {
    // 调试权限信息
    //this.debugPermissions()
    this.doQueryList({
      pageNo: 1
    })
    this.getConfig()
    this.getStandingList()
    this.getDiscountList()
    this.getLabelList()
    this.getAddressList()
    this.getTechnicianList()
    this.getBusinessList()
    this.getOptionList()
    this.getFieled()
  },
  methods: {
    serviceCycleText,
    cityCompanySubmit(type, row) {
      if (type) {
        this.popType = 5
        this.$refs.bannerAdd.handleUpdate({
          'row': row,
          'command': 5
        })
      }
      this.doQueryList({})
    },
    handleAddCallback(row) {
      if (row) {
        this.$refs.cityCompanyVue.handleUpdate(row)
      }
      this.doQueryList({})
    },
    handleChangeFields() {
      this.$refs.fieldsPopup.open();
    },
    doColumnList(checkedList) {
      if (checkedList && !checkedList.length) return
      let allList = JSON.parse(JSON.stringify(this.allTemplate))
      let newL = allList.filter(item => checkedList.indexOf(item.prop) > -1)
      this.dynamicHeaders = newL;
      localStorage.setItem('clientTableColumn', JSON.stringify(newL))
    },
    getFieled() {
      if (localStorage.getItem('clientTableColumn')) {
        let tColumn = JSON.parse(localStorage.getItem('clientTableColumn'))
        this.dynamicHeaders = tColumn
      } else {
        this.dynamicHeaders = this.allTemplate
      }
    },
    businessFilter(e) {
      // console.log('e',e)
      this.getBusinessList(e)
    },
    technicianFilter(e) {
      // console.log('e',e)
      this.getTechnicianList(e)
    },
    checkboxT(row, index) {
      if (row.customer.mainId) {
        return false
      } else {
        return true
      }
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        customerType: 3,
        portraitStatus: '',
        serviceCycleFilter: ''
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    handleUpdates(row) {
      this.handleUpdate(row, 1)
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({
        pageNo: 1
      })
      // console.log("activeName: ",this.activeName);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.isOpenSea = 0
      console.log('this.query: ', this.query, this.dateTime);
      // return
      let query = {
        ...this.query
      }
      if (this.query.addrid) {
        query.addrid = this.query.addrid[this.query.addrid.length - 1]
      }

      if (this.query.timeType && this.dateTime && this.dateTime.length) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      if (this.dateTime && this.dateTime.length && !this.query.timeType) {
        this.dateTime = null
      }
      // return
      // this.query.displayPosition=this.activeName
      this.listLoading = true
      return clientListApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 修改学习权限
    changeSwitch(row) {
      console.log('row: ', row);
      let params = {
        canStudy: row.customer.canStudy,
        ywInternTime: row.customer.ywInternTime,
        isIntern: row.customer.isIntern,
        customerId: row.customer.id
      }
      // return
      clientListApi.updateStudy(params)
      this.$message.success('状态修改成功')
    },
    // 获取城市公司
    getOptionList() {
      cityCompanyApi.getOption().then(({
        data
      }) => {
        this.companyList = data
        // console.log('城市公司: ',data);
      })
    },
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'shopType,dayAVGOutpatients,employeeNums,carryProjects,custFranchiseFeeL7,custFranchiseFeeL6,upyanxiubansendgood,uptiyanbansendgood,tyupxybansendgood'
      }).then(({
        data
      }) => {
        this.configList = data.list
        // console.log("配置: ",data);
      })
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.standingList = data
        // console.log('客户身份: ',data);
      })
    },
    // 获取折扣组列表
    getDiscountList() {
      sysProfitRatioApi.fetchList({
        isEnable: 1
      }).then(({
        data
      }) => {
        this.discountList = data
        // console.log('折扣组列表: ',data);
      })
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({
        data
      }) => {
        this.addressList = this.formatCascaderData(data)
        // console.log('地区列表: ',data);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    // 获取标签列表
    getLabelList() {
      clientLabelApi.fetchList({
        pageNo: 1,
        pageSize: 999,
        tagStatus: 1
      }).then(({
        data
      }) => {
        this.labelList = data.list.map(i => {
          return {
            id: i.customerTagGroup.id,
            name: i.customerTagGroup.groupName,
            children: i.customerTagList
          }
        })
       
      })
    },
    // 获取技术老师列表
    getTechnicianList(e) {
      let obj = {
        status: 10,
        pageNo: 1,
        pageSize: 100
      }
      // if(e){
      obj.realName = e
      // }
      technicianInfoApi.fetchList(obj).then(({
        data
      }) => {
        this.technicianList = data.list
        // console.log('技术老师列表: ',data);
      })
    },
    // 获取业务员列表
    getBusinessList(e) {
      let obj = {
        customerTypes: 2,
        isGetAllParent: true,
        isDeparted: 0,
        pageNo: 1,
        pageSize: 100
      }
      // if(e){
      obj.name = e
      // }
      clientListApi.getListPageForMini(obj).then(({
        data
      }) => {
        this.businessList = data.list
        // console.log('业务员列表: ', data);
      })
    },
    handleClearCache(row) {
      this.$common.confirm('是否确认清除缓存')
        .then(() => userApi.delCache({ userId: row.customerUserPO.id }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      this.popType = command.command
      if ([20].includes(command.command)) {
        this.$refs.cityCompanyVue.handleUpdate(command.row)
      }
      if ([21].includes(command.command)) {
        this.handleClearCache(command.row)
      }
      if ([22].includes(command.command)) {
        this.$refs.addressManageVue.handleUpdate(command.row)
      }
      if ([13, 14, 15].includes(command.command)) {
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择客户')
          return
        }
        console.log('command: ', command, this.selectItems);
        let ids = this.selectItems.map(row => row.customer.id)
        let txt = ""
      }
      if (command.command && (command.command < 10)) {
        this.$refs.bannerAdd.handleUpdate(command)
      }
      if ([13, 14].includes(command.command)) {
        this.$refs.bannerAdd.handleUpdate({
          command: command.command,
          row: this.selectItems
        })
      }
      if (command.command == 11) {
        this.showDisableAccountDialog(command.row)
      }
      if (command.command == 10) {
        this.$router.push("/log/log?type=2&id=" + command.row.customer.id);
      }
      if (command.command == 23) {
        this.otherFollowForm.customerId = command.row.customer.id
        this.otherFollowUrlList = []
        this.$nextTick(() => { this.$refs.otherFollowForm && this.$refs.otherFollowForm.resetFields() })
        this.loadOtherFollowCategoryList()
        this.otherFollowDialogVisible = true
      }
      if (command.command == 12) {
        this.$common.confirm(command.row.customerUserPO.entryInhibited ? '是否确认恢复登录' : '是否确认禁止用户登录，禁用了客户不能登录app').then(
          async () => {
            // console.log('=========');
            await userApi.updateEntryInhibited({
              entryInhibited: command.row.customerUserPO.entryInhibited == 1 ? 0 : 1,
              id: command.row.customerUserPO.id
            })
          })
          .then(() => {
            this.$common.showMsg('success', `${command.row.customerUserPO.entryInhibited ? '恢复' : '禁止'}成功`)
            this.doQueryList({
              pageNo: 1
            })
          })
      }
      if (!command.command || command.command == 15) {
        this.$prompt(
          `是否确认将${command.command == 15 ? this.selectItems.length : command.row.customer.name}${command.command == 15 ? '个客户' : ''}移入公海？`,
          '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入移入公海原因',
        }).then(({
          value
        }) => {
          let arr = []
          if (!command.command) {
            arr = [{
              id: command.row.customer.id,
              isOpenSea: 1,
              state: 1,
              openSeaReason: value,
              dataCompareLogType2: 13
            }]
          } else {
            arr = this.selectItems.map(item => ({
              id: item.customer.id,
              isOpenSea: 1,
              state: 1,
              openSeaReason: value,
              dataCompareLogType2: 13
            }))
          }
          clientListApi.updateAccount(arr)
        })
          .then(() => {
            this.$message.success('提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度')
            this.doQueryList({
              pageNo: 1
            })
          })
      }
      // if (command.command === 1) {
      //   this.handleBatchState(ids, 1)
      // } else if (command.command === 2) {
      //   this.handleBatchState(ids, 2)
      // } else if (command.command === 3) {
      //   this.handleDeleteBatch()
      // }
    },
    //查看信息
    handleShowDetail(id) {
      this.$emit('handleShow', id, 2)
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.popType = 0
      this.$refs.bannerAdd.handleUpdate({
        row: {},
        command: 0
      })
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.clientShow.handleShow(row.customerCertificates)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row, type) {
      if ([1, 2, 9].includes(type)) {
        this.popType = type
        this.$refs.bannerAdd.handleUpdate({
          row,
          command: type
        })
      }
      if (type == 3) {
        this.$refs.labelAdd.handleUpdate(row)
      }
      if (!type) {
        this.$refs.subaccount.handleShow(row)
      }
      if (type == 10) {
        this.$router.push("/export/list?code=EEForCustomerFollowUp");
      }
    },
    handleDownload() {
      this.$router.push("/export/list?code=CustomerDownloadExcelDiy3")
    },
    handleDownloadFollowUp() {
      // 跳转到导出页面
      this.$router.push("/export/list?code=EEForCustomerFollowUp")
    },
    
  
    handleDownTemplate() {
      clientListApi.importExcelCustomertemplate()
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      clientListApi.importExcelCustomer(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    loadOtherFollowCategoryList() {
      if (this.otherFollowCategoryList.length) return
      sysDataconstantApi.fetchCode({ code: 'addfollowCustRecordType' }).then(({ data }) => {
        if (data && data.content) {
          const content = data.content.trim()
          if (content.startsWith('[')) {
            this.otherFollowCategoryList = JSON.parse(content)
          } else {
            this.otherFollowCategoryList = content.split(',').map(s => s.trim()).filter(Boolean)
          }
        } else {
          this.otherFollowCategoryList = []
        }
      }).catch(() => { this.otherFollowCategoryList = [] })
    },
    handleSubmitOtherFollow() {
      this.$refs.otherFollowForm.validate(valid => {
        if (!valid) return
        this.otherFollowSubmitLoading = true
        const form = { ...this.otherFollowForm, followUpUrl: this.otherFollowUrlList.map(f => f.url).join(',') }
        otherFollowCustRecordApi.save(form).then(() => {
          this.$common.showMsg('success', '新增成功')
          this.otherFollowDialogVisible = false
        }).finally(() => {
          this.otherFollowSubmitLoading = false
        })
      })
    },
    resetOtherFollowForm() {
      this.$refs.otherFollowForm && this.$refs.otherFollowForm.resetFields()
      this.otherFollowUrlList = []
    },
    showDisableAccountDialog(row) {
      this.currentDisableRow = row
      this.isDeleteSysUser = false // 默认不清空登录账号：同一手机号可能还有别的有效资料共用它，删了那条也登不上
      this.disableAccountVisible = true
    },
    confirmDisableAccount() {
      clientListApi.updateAccount([{
        id: this.currentDisableRow.customer.id,
        isOpenSea: 0,
        deleted: true,
        dataCompareLogType2: 13,
        isDeleteSysUser: this.isDeleteSysUser
      }]).then(() => {
        this.$message.success('提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度')
        this.disableAccountVisible = false
        this.doQueryList({
          pageNo: 1
        })
      })
    }
  }
}
</script>
<style>
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}

/* 禁用账户弹窗样式 */
.disable-account-content {
  .warning-text {
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    display: flex;
    align-items: flex-start;
  }
  
  .checkbox-section {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #f0f0f0;
  }
}
</style>
